// export const BASE_URL = 'https://localhost:5001/api/';
// export const BASE_URL1 = 'https://localhost:5001';
export const BASE_SUBDOMAIN = "/nexuspickup"
export const BASE_URL = 'https://etq-demo.etq.com.au/NexusPickupApi/api/';
export const BASE_URL1 = 'https://etq-demo.etq.com.au';

// export const BASE_URL = 'http://localhost/NexusPickupApi/api';
// export const BASE_URL1 = 'http://localhost';

// export const BASE_URL = 'https://pickup.gentronics.com.au/NexusPickupApi/api/';
// export const BASE_URL1 = 'https://pickup.gentronics.com.au';
const apiVersion = 'v1'
export const GET_INVOICES_SETTING_URL =  `${apiVersion}/Invoice/GetSetting`;
export const GET_INVOICES_FOR_TODAY_URL =  `${apiVersion}/Invoice/GetInvoicesForToday/`;
export const SEARCH_INVOICE_BY_INVOICE_NUMBER_URL =  `${apiVersion}/Invoice/GetInvoiceByInvoiceNumber`;
export const SEARCH_INVOICE_BY_CUSTOMER_CODE =  `${apiVersion}/Invoice/GetInvoicesByCustomerCode/`;
export const SEARCH_INVOICE_BY_CUSTOMER_NAME =  `${apiVersion}/Invoice/GetInvoicesByCustomerName/`;
export const SEARCH_INVOICE_BY_CUSTOMER_ORDER_NUMBER =  `${apiVersion}/Invoice/GetInvoicesByCustomerOrderNumber/`;
export const GET_INVOICE_DETAIL_URL =  `${apiVersion}/ViewInvoice/GetInvoiceDetail/`;
export const GET_INVOICE_DETAIL_LINES_URL =  `${apiVersion}/ViewInvoice/GetInvoiceDetailLines/`;
export const SAVE_PICKUP_DETAIL_URL =  `${apiVersion}/Invoice/SavePickupDetail`;
export const SEARCH_CUSTOMERS_BY_CODE_URL =  `${apiVersion}/Customer/SearchCustomersByCode?searchKey=`;
export const SEARCH_CUSTOMERS_BY_NAME_URL =  `${apiVersion}/Customer/SearchCustomersByName?searchKey=`;
export const LOGIN_URL =  `${apiVersion}/Login/LoginUser`;
export const FULLY_QUALIFIED_REFRESH_TOKEN_URL = `${BASE_URL}${apiVersion}/Login/RefreshToken`;
export const REFRESH_TOKEN_URL = `${apiVersion}/Login/RefreshToken`;
export const SEARCH_CUSTOMER_ORDER_NUMBER_URL =  `${apiVersion}/Order/SearchCustomerOrderNumber/`;

export const LOGOUT_USER_URL = `${BASE_URL}${apiVersion}/Logout/LogoutUser`;

